import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import React from "react";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import logo from "./logo.png";
import phone from "./phone-call.png";
import WifiCalling3OutlinedIcon from "@mui/icons-material/WifiCalling3Outlined";
import AppBar from "@mui/material/AppBar";
import Paper from "@mui/material/Paper";

// clearAll, setActiveStep
function ToolbarComponent(props) {
    return (
        <Toolbar style={{backgroundColor: '#f6f5f5', paddingLeft: 8}} sx={{ py: { xs: 0, sm: 'auto' } }} onClick={() => {
            props.clearAll();
            props.setActiveStep(0)
        }}>
            <Paper style={{width: '100%'}} elevation={6}>
            <Grid container justifyContent="space-between" alignItems="center"
                  sx={{ pl: { xs: '6px', sm: '10px' }, pr: { xs: '12px', sm: '30px' } }}
            >
                <Grid item xs={2} sm={4}>
                    <Box component="img" src={logo} alt="6 Плюс"
                        sx={{ width: { xs: 68, sm: 80 }, height: { xs: 68, sm: 80 }, cursor: 'pointer', display: 'block' }}
                    />
                </Grid>

                <Grid item xs={10} sm={8}>
                    <Grid container justifyContent="flex-end" alignItems="center" spacing={2}>

                        <Grid item>
                            <Box component="img" src={phone}
                                sx={{ width: { xs: 32, sm: 42 }, height: { xs: 32, sm: 42 }, display: 'block' }}
                            />
                        </Grid>

                        <Grid item>
                            <Grid coontainer justifyContent="flex-end">
                                <Typography sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }}>За въпроси и поръчки</Typography>
                            <a href="tel:+359882606606" style={{color: '#ffd200', textDecoration: 'none', textShadow: '8px 2px #fff'}}>
                                <Typography variant="h5" noWrap sx={{ fontSize: { xs: '1.15rem', sm: '1.5rem' } }}>
                                    0882 606 606
                                </Typography>
                            </a>
                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>

            </Grid>
            </Paper>


        </Toolbar>
    );
}
export default ToolbarComponent;